import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useT } from "@/i18n/I18nContext";
import { StarRating } from "@/components/StarRating";
import { SellerBadge } from "@/components/SellerBadge";
import { ShieldCheck, MapPin, ArrowRight } from "lucide-react";

export const TrustedSellers = () => {
  const { t } = useT();
  const [sellers, setSellers] = useState([]);

  useEffect(() => { api.get("/trusted-sellers").then((r) => setSellers(r.data)).catch(() => {}); }, []);

  if (sellers.length === 0) return null;

  return (
    <section className="bg-muted/40 border-y border-border">
      <div className="container-page py-16">
        <div className="mb-8">
          <h2 className="font-heading font-bold text-2xl sm:text-3xl lg:text-4xl tracking-tight text-secondary">
            {t("trusted.title")}
          </h2>
          <p className="text-muted-foreground mt-2">{t("trusted.subtitle")}</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {sellers.map((s, i) => (
            <Link key={s.id} to={`/profil-vendeur/${s.id}`} data-testid={`trusted-seller-${s.id}`}
              style={{ animationDelay: `${i * 70}ms` }}
              className="group rounded-2xl bg-card border border-border p-5 hover:shadow-xl hover:-translate-y-1 transition-[transform,box-shadow] animate-fade-up">
              <div className="flex items-center justify-between">
                <span className="h-12 w-12 rounded-full bg-secondary text-secondary-foreground flex items-center justify-center font-heading font-bold text-lg">
                  {s.name.charAt(0)}
                </span>
                <SellerBadge badge={s.badge} premium={s.premium} size="sm" />
              </div>
              <h3 className="mt-3 font-heading font-semibold text-secondary flex items-center gap-1.5 group-hover:text-primary transition-colors">
                {s.name} <ShieldCheck className="h-4 w-4 text-secondary" />
              </h3>
              <p className="text-xs text-muted-foreground flex items-center gap-1 mt-0.5">
                <MapPin className="h-3 w-3" /> {s.city ? `${s.city}, ` : ""}{s.region || t("hero.badge")}
              </p>
              <div className="mt-2"><StarRating value={s.rating_avg} count={s.rating_count} size={13} /></div>
              <p className="mt-3 text-sm text-primary font-semibold flex items-center gap-1">
                {s.listings} {t("trusted.listings")} <ArrowRight className="h-3.5 w-3.5 group-hover:translate-x-1 transition-transform" />
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
